import { configureStore } from '@reduxjs/toolkit';
import { injectStore } from './apps/api.service';
import CustomizerReducer from './customizer/CustomizerSlice';
import AppReducer from './apps/slices/AppSlice';
import UserReducer from './apps/slices/UserSlice';
import WarehouseReducer from './apps/slices/WarehouseSlice';
import ShopReducer from './apps/slices/ShopSlice';
import SupplierReducer from './apps/slices/SupplierSlice';
import CategoryReducer from './apps/slices/CategorySlice';
import ExpenseCategoryReducer from './apps/slices/ExpenseCategorySlice';
import PermissionReducer from "./apps/slices/PermissionSlice";
import RoleReducer from "./apps/slices/RoleSlice";
import PurchaseReducer from './apps/slices/PurchaseSlice';
import UomReducer from "./apps/slices/UomSlice";
import RawMaterialReducer from "./apps/slices/RawMaterialSlice";
import UomConversionReducer from "./apps/slices/UomConversionSlice";
import FinishedGoodReducer from "./apps/slices/FinishedGoodSlice";
import ProductionReducer from "./apps/slices/ProdcutionSlice";
import BankReducer from "./apps/slices/BankSlice";
import CreditPurchaseReducer from "./apps/slices/CreditPurchaseSlice";
import InventoryReducer from "./apps/slices/InventorySlice";
import OrderReducer from "./apps/slices/OrderSlice";
import StockReturnReducer from "./apps/slices/StockReturnSlice";
import AdjustmentReducer from './apps/slices/StockAdjustmentSlice';
import BrandReducer from './apps/slices/BrandSlice';
import RegionReducer from './apps/slices/RegionSlice';
import NotificationReducer from './apps/slices/NotificationSlice';
import DiscrepancyReducer from './apps/slices/DiscrepancySlice';
import ProductionOrderReducer from './apps/slices/productionOrderSlice';
import BackorderReducer from './apps/slices/BackorderSlice';
import ShopBalanceReducer from './apps/slices/ShopBalanceSlice';
import BillReducer from './apps/slices/BillSlice';
import PaymentReducer from './apps/slices/PaymentSlice';
import ParLevelReducer from './apps/slices/ParLevelSlice';
import ReportReducer from './apps/slices/ReportSlice';
import StockMovementReducer from './apps/slices/stockMovementSlice';
import InternalTransferReducer from './apps/slices/InternalTransferSlice';
import StockRequestReducer from './apps/slices/StockRequestSlice';
import WarehouseOrderReducer from './apps/slices/WarehouseOrderSlice';
import ExpenseReducer from './apps/slices/ExpenseSlice';
import WarehouseConsumptionReducer from './apps/slices/WarehouseConsumptionSlice';
import ConsumptionTypeReducer from './apps/slices/ConsumptionTypeSlice';
import PriceReducer from './apps/slices/PriceSlice';
import VersionReducer from './apps/slices/VersionSlice';

export const store = configureStore({
  reducer: {
    app: AppReducer,
    customizer: CustomizerReducer,
    user: UserReducer,
    warehouse: WarehouseReducer,
    shop: ShopReducer,
    supplier: SupplierReducer,
    category: CategoryReducer,
    expenseCategory: ExpenseCategoryReducer,
    permission: PermissionReducer,
    role: RoleReducer,
    purchase: PurchaseReducer,
    uom: UomReducer,
    rawMaterial: RawMaterialReducer,
    conversion: UomConversionReducer,
    finishedGood: FinishedGoodReducer,
    production: ProductionReducer,
    bank: BankReducer,
    creditPurchase: CreditPurchaseReducer,
    inventory: InventoryReducer,
    order: OrderReducer,
    stockReturn: StockReturnReducer,
    adjustment: AdjustmentReducer,
    brand: BrandReducer,
    region: RegionReducer,
    notification: NotificationReducer,
    discrepancy: DiscrepancyReducer,
    productionOrder: ProductionOrderReducer,
    backorder: BackorderReducer,
    shopBalance: ShopBalanceReducer,
    bill: BillReducer,
    payment: PaymentReducer,
    parLevel: ParLevelReducer,
    report: ReportReducer,
    stockMovement: StockMovementReducer,
    internalTransfer: InternalTransferReducer,
    stockRequest: StockRequestReducer,
    warehouseOrder: WarehouseOrderReducer,
    expense: ExpenseReducer,
    warehouseConsumption: WarehouseConsumptionReducer,
    consumptionType: ConsumptionTypeReducer,
    price: PriceReducer,
    version: VersionReducer,
  },
});

injectStore(store.dispatch);

export default store;
